import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { Divider, Grid, Paper, Typography } from '@material-ui/core';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import { textToSnakeCase } from '../../utils/utils';

function RestaurantDetailsCard() {
  const classes = styles();
  const restaurant = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );
  const { t } = useTranslation();

  return (
    <Paper className={classes.paperStyle}>
      <Grid container spacing={0}>
        <Grid item sm={6} xs={12} lg={8}>
          <div className={classes.addressDiv}>
            <Typography variant="h6">
              {restaurant.physical_address_address_line1}{' '}
              {restaurant.physical_address_city}, {restaurant['State/Province']}{' '}
              {restaurant.physical_address_postalCode} - {restaurant.Country} #
              {restaurant.RestaurantNumber}{' '}
            </Typography>
          </div>
        </Grid>
        <Grid item sm={6} xs={12} lg={4}>
          <div className={classes.flexCenter}>
            <Divider orientation="vertical" />
            <div className={classes.textFlexCenter}>
              <Typography>
                {t(
                  `restaurant.status.${textToSnakeCase(
                    restaurant.RestaurantStatus,
                  )}`,
                  restaurant.RestaurantStatus,
                )}
              </Typography>
              <Typography variant="caption">
                {t('restaurant.home.status')}
              </Typography>
            </div>
            <div className={classes.textFlexCenter}>
              <Typography>{restaurant.FranchiseGroup}</Typography>
              <Typography variant="caption">
                {t('restaurant.home.franchiseGroup')}
              </Typography>
            </div>
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default RestaurantDetailsCard;
